import React, { useContext } from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import { CIS_USER_ID_CONTEXT } from '../../app/LookupContext'
import { RelationshipCalculatorContext } from '../../relationshipCalculator/RelationshipCalculatorContext'
import { UserContext } from '../UserContext'
import RelationshipCalculatorForm from '../../relationshipCalculator/RelationshipCalculatorForm'

const USER_PREFIX = 'u'
const PERSON_PREFIX = 'p'
const CIS_USER_ID_PREFIX = 'cis'

const UserRelationshipCalculator = () => {
  usePageView({ page_detail: 'DMConsole:UserRelationshipCalculator' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.user.relationshipCalculator'))
  const { currentUser } = useContext(UserContext)
  const relCalculatorContext = useContext(RelationshipCalculatorContext)

  // if there is no context it is a contributor Id with prefix 'u'
  let context = currentUser.input.context ? currentUser.input.context : USER_PREFIX
  context = context === CIS_USER_ID_CONTEXT ? CIS_USER_ID_PREFIX : context
  let userId = currentUser.input.userId
  if (context !== USER_PREFIX && context !== CIS_USER_ID_PREFIX) {
    userId = currentUser.contributorId
    context = USER_PREFIX
    if (userId === null) {
      const items = currentUser.metadata.items
      const idItem = items.find((item) => item.field === 'contributorId' || item.field === 'pid')
      userId = idItem.value.value
      context = idItem.field === 'contributorId' ? USER_PREFIX : PERSON_PREFIX
    }
  }

  const metadata = currentUser.metadata
  const updateCalculatorContext = () => {
    // left has the current user the first time
    if (relCalculatorContext.summary || !relCalculatorContext.insetInlineStart.inputId) {
      relCalculatorContext.insetInlineStart.prefix = context || USER_PREFIX
      relCalculatorContext.insetInlineStart.inputId = userId
      relCalculatorContext.insetInlineStart.validId = true
      relCalculatorContext.insetInlineStart.personId =
        metadata.items && metadata.items.filter((item) => item.field === 'pid')[0]?.value.value
      const lifeSpan = metadata.items.find((item) => item.field === 'lifeSpan')?.value.value
      if (metadata.items && lifeSpan) {
        relCalculatorContext.insetInlineStart.label = metadata.header.concat('(').concat(lifeSpan).concat(')')
      } else {
        relCalculatorContext.insetInlineStart.label = ''
      }
    }
    // right side is clear first time
    if (relCalculatorContext.summary || !relCalculatorContext.insetInlineEnd.inputId) {
      relCalculatorContext.insetInlineEnd.prefix = PERSON_PREFIX
      relCalculatorContext.insetInlineEnd.inputId = ''
      relCalculatorContext.insetInlineEnd.validId = false
      relCalculatorContext.insetInlineEnd.personId = ''
      relCalculatorContext.insetInlineEnd.label = ''
      relCalculatorContext.summary = false
    }
  }

  updateCalculatorContext()

  return <RelationshipCalculatorForm />
}
export default UserRelationshipCalculator
